/* MARMOT F2 — чиста логика на попъпа за доставка (без DOM).

   Изнесена отделно, за да е тестима с `node --test` без браузър и за да
   се преизползва от marmot-delivery-popup.js в браузъра (UMD: закача се на
   window.MarmotF2Logic, а в Node се експортва през module.exports).

   Тук НЯМА достъп до document/window — само пресмятания и правила. */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.MarmotF2Logic = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var BGN_RATE = 1.95583; // фиксиран курс EUR→BGN

  /* Валута — огледало на snippets/marmot-price.liquid:
     „15,34 € (30.00 лв)" — евро със знак отзад и десетична запетая,
     левовете в скоби с точка, integer аритметика в стотинки (без float дрейф). */
  function money(cents, dual) {
    var c = Math.round(cents || 0);
    var eu = Math.floor(c / 100);
    var ec = c % 100;
    var eur = eu + ',' + (ec < 10 ? '0' : '') + ec + ' €';
    if (dual === false) return eur;
    var lv = Math.floor((c * 195583 + 50000) / 100000); // лв в стотинки
    var lu = Math.floor(lv / 100);
    var lc = lv % 100;
    return eur + ' (' + lu + '.' + (lc < 10 ? '0' : '') + lc + ' лв)';
  }

  function methodKey(courier, service) {
    return courier && service ? courier + ':' + service : null;
  }

  // Само ВИДИМИ етикети в попъпа. Заглавието на shipping line-а в Draft Order-а
  // се строи от бекенда по courier/service (напр. „До адрес speedy") — Ф1 чете
  // адреса в този формат, контрактът #D774 стъпва на него. Тук НЕ го пипаме.
  var METHOD_LABELS = {
    'speedy:office': 'До офис или автомат на Speedy',
    'speedy:address': 'До личен адрес',
    'econt:office': 'До офис или еконтомат на Еконт',
    'boxnow:office': 'BOX NOW автомат'
  };

  // Кратко пояснение под етикета. Само методи, които човек може да не познава;
  // старите три нямат ред и разметката им остава същата.
  var METHOD_HINTS = {
    'boxnow:office': 'известие по SMS и имейл – взимаш пратката от автомата 24/7'
  };

  function methodHint(key) {
    return METHOD_HINTS[key] || null;
  }

  /* Бележката над бутона за плащане (стъпка „Преглед"). Начинът на плащане се
     избира чак на страницата на Shopify, затова при BOX NOW казваме още тук, че
     наложеният платеж там не е в брой (boxnow-tekstove, 10.10.2026). Текстът за
     Спиди и Еконт е същият като в разметката. */
  var PAYMENT_NOTE = 'Следва сигурната страница за плащане – с карта или наложен платеж.';
  // \u00a0 – „BOX NOW" и „Apple Pay"/„Google Pay" не се чупят на два реда на телефон.
  var PAYMENT_NOTE_BOXNOW = 'При BOX\u00a0NOW наложеният платеж не е в брой: плащаш с карта, Apple\u00a0Pay или Google\u00a0Pay през линк, който BOX\u00a0NOW ти праща по имейл, SMS или Viber.';

  function paymentNoteText(courier) {
    return courier === 'boxnow' ? PAYMENT_NOTE + ' ' + PAYMENT_NOTE_BOXNOW : PAYMENT_NOTE;
  }

  /* Скрит режим на BOX NOW (boxnow-skrit-b, 29.09.2026). Договорът е от част А:
     `methods` виждат всички; скритият метод е САМО в `hiddenMethods`, с
     visibility "hidden"; масивът липсва изцяло, когато няма скрит метод.
     Скритият BOX NOW се добавя към списъка само при ?f2_boxnow=1 в адреса на
     страницата. Параметърът отключва само BOX NOW – друг скрит метод, ако някога
     се появи, остава скрит. Без параметъра списъкът е точно `methods`. */
  var HIDDEN_PARAM = 'f2_boxnow';

  function hiddenRevealRequested(search) {
    var q = String(search || '').replace(/^\?/, '');
    if (!q) return false;
    return q.split('&').some(function (part) {
      var i = part.indexOf('=');
      var name = i < 0 ? part : part.slice(0, i);
      var value = i < 0 ? '' : part.slice(i + 1);
      return name === HIDDEN_PARAM && value === '1';
    });
  }

  function visibleMethods(cfg, search) {
    var base = cfg && Array.isArray(cfg.methods) ? cfg.methods.slice() : [];
    if (!hiddenRevealRequested(search)) return base;
    var hidden = cfg && Array.isArray(cfg.hiddenMethods) ? cfg.hiddenMethods : [];
    hidden.forEach(function (m) {
      if (!m || m.courier !== 'boxnow' || m.visibility !== 'hidden') return;
      var key = methodKey(m.courier, m.service);
      var dup = base.some(function (x) { return x && methodKey(x.courier, x.service) === key; });
      if (!dup) base.push(m);
    });
    return base;
  }

  /* Бутон „Поръчай“ извън количката на страницата на количката праща към /cart.
     Параметърът за скрития режим се носи нататък, иначе презареждането го губи. */
  function cartHref(search) {
    return hiddenRevealRequested(search) ? '/cart?' + HIDDEN_PARAM + '=1' : '/cart';
  }

  /* BOX NOW има само автомати: думата „офис" там подвежда. За куриер с офиси
     функцията връща null и попъпът оставя текстовете от снипета, т.е. Спиди и
     Еконт виждат точно това, което виждаха преди. */
  var LOCKER_ONLY = { boxnow: true };

  function isLockerOnly(courier) {
    return LOCKER_ONLY[courier] === true;
  }

  function officeTexts(courier) {
    if (!isLockerOnly(courier)) return null;
    return {
      label: 'Автомат',
      placeholder: 'Автомат или адрес в града',
      empty: 'Няма автомат в този град по това търсене.',
      required: 'Избери автомат от списъка.',
      notFound: 'Избраният автомат вече не е наличен. Избери друг автомат.',
      cacheEmpty: 'Списъкът с автомати временно не е наличен. Опитай пак след малко.'
    };
  }

  /* Честният ред под полето за офис: колко има градът и колко виждаш сега. */
  function officeHintText(total, shown, truncated, courier) {
    if (!total) return null;
    if (truncated) return 'Показани са първите ' + total + ' в града — пиши, за да стесниш търсенето.';
    if (shown < total) return 'Показани ' + shown + ' от ' + total + ' в града.';
    if (isLockerOnly(courier)) {
      return total === 1 ? '1 автомат в града.' : total + ' автомата в града – пиши, за да търсиш.';
    }
    if (total === 1) return '1 офис в града.';
    return total + ' офиса и автомата в града — пиши, за да търсиш.';
  }

  /* Истина, ако `needle` стои в името като цяло парче – между разделители
     (запетая, тире) или краищата на името: „BOX NOW 12 – ул. Х 5, София".
     Подниз не стига: град „Бяла" не бива да се скрие заради „Бяла Слатина".
     Парчето може да съдържа своя запетая („ж.к. Люлин, бл. 520") и може да
     продължава с уточнение в скоби („ул. Х 5 (Лидл)"). */
  function containsText(haystack, needle) {
    var h = String(haystack || '').toLowerCase();
    var n = String(needle || '').trim().toLowerCase();
    if (!n) return false;
    var from = 0;
    while (true) {
      var i = h.indexOf(n, from);
      if (i < 0) return false;
      var before = h.slice(0, i);
      var after = h.slice(i + n.length);
      if ((!before.trim() || /(,|–|—|\s-)\s*$/.test(before)) &&
          (!after.trim() || /^\s*(,|–|—|-\s|\()/.test(after))) return true;
      from = i + 1;
    }
  }

  /* Как се показва един офис от `/checkout/offices` и какво влиза в състоянието
     при избор. За Спиди и Еконт е точно заварното: име + таг „автомат" + адрес,
     етикет „име · град · адрес". При BOX NOW `name` вече носи номер, адрес и
     град, затова адресът и градът се добавят само ако ги няма в името – иначе
     един и същ адрес стои два пъти на телефонния екран.

     officeId е ВИНАГИ externalId като низ – договорът с бекенда (порция 1, §7). */
  function officeView(o, courier) {
    o = o || {};
    var name = o.name || '';
    if (!isLockerOnly(courier)) {
      return {
        name: name,
        tag: o.type === 'locker' ? 'автомат' : '',
        address: o.address || '',
        inputText: name + (o.type === 'locker' ? ' (автомат)' : ''),
        label: [o.name, o.city, o.address].filter(Boolean).join(' · '),
        officeId: String(o.externalId),
        officeType: o.type || null
      };
    }
    var extra = [o.city, o.address].filter(function (part) {
      return part && !containsText(name, part);
    });
    return {
      name: name,
      tag: '',
      address: containsText(name, o.address) ? '' : (o.address || ''),
      inputText: name,
      label: [name].concat(extra).filter(Boolean).join(' · '),
      officeId: String(o.externalId),
      officeType: o.type || null
    };
  }

  /* §4.1 — смяна на метода на доставка.
     Ако методът се смени (различен куриер ИЛИ различна услуга), избраният офис
     се нулира, а всеки започнат draft опит се обезсилва (нов idempotency ключ →
     null, за да се генерира наново). Така Speedy office id не може да се закачи
     за Econt пратка, нито стар офис да пътува към новосъздадена поръчка.

     prev: { courier, service, officeId, officeLabel, officeType, idempotencyKey, discount }
     method: { courier, service }
     Връща новото състояние + officeReset (дали офисът е нулиран). */
  function applyMethodChange(prev, method) {
    prev = prev || {};
    var prevKey = methodKey(prev.courier, prev.service);
    var nextKey = methodKey(method.courier, method.service);
    // „Нулиране" има само ако е ИМАЛО предишен метод и той се сменя. Първият
    // избор (от нищо) не е нулиране — няма какво да се обезсили.
    var changed = !!prevKey && prevKey !== nextKey;
    var next = {
      courier: method.courier,
      service: method.service,
      officeId: prev.officeId || null,
      officeLabel: prev.officeLabel || null,
      officeType: prev.officeType || null,
      idempotencyKey: prev.idempotencyKey || null,
      // Отстъпката НЕ зависи от метода, затова първият избор (от нищо) я
      // запазва – точно това прави един код една заявка вместо две. Смяната
      // между два реални метода я нулира: клиентът е сменил параметър и
      // проверяваме наново, вместо да носим застояла стойност (§4.1).
      discount: changed ? null : (prev.discount || null),
      discountReset: changed,
      officeReset: false,
      needsOffice: method.service === 'office',
      needsAddress: method.service === 'address'
    };
    if (changed) {
      next.officeId = null;
      next.officeLabel = null;
      next.officeType = null;
      next.idempotencyKey = null; // обезсилва започнат draft опит
      next.discount = null;
      next.discountReset = true;
      next.officeReset = true;
    }
    return next;
  }

  function freeThresholdCents(cfg) {
    return Math.round(((cfg && cfg.freeShippingThresholdEur) || 0) * 100);
  }

  /* Безплатна доставка: над прага, ИЛИ точно на прага — границата е
     ВКЛЮЧВАЩА (решение на Николай, 28.07.2026): количка точно 30,00 € получава
     безплатна доставка. Само изричното freeShippingInclusive === false връща
     старото строго „над прага". Точно огледало на isFreeShipping в
     shopifyCheckoutService.ts; двете страни смятат върху едно и също число —
     сумата на final_line_price по редовете на количката. */
  function isFreeShipping(subtotalCents, cfg) {
    if (!cfg || !cfg.freeShippingThresholdEur) return false;
    var t = freeThresholdCents(cfg);
    if (subtotalCents > t) return true;
    return subtotalCents === t && cfg.freeShippingInclusive !== false;
  }

  /* Прагът за подаръка (раздел 12 на брифа). Огледало на giftMeetsThreshold в
     shopifyCheckoutService.ts и смята върху СЪЩОТО число като доставката —
     сумата на final_line_price, без самата доставка.

     Границата е ВКЛЮЧВАЩА: точно 20,00 € получава подарък.

     Две нарочни отваряния, и двете покрити от сървъра, който е истинският
     пазач:
     - липсваща или негодна настройка (стар сървър, нов код в темата) НЕ гаси
       подаръка. Обратното би значело, че едно липсващо поле мълчаливо отнема
       подаръка на всички;
     - непознат сбор (количката още не е върнала) също не гаси стъпката.
       Скрита стъпка при количка НАД прага е тихо отнет подарък без път назад,
       докато показана стъпка ПОД прага води до вече покрития изход
       „подаръкът отпадна", а поръчката минава. */
  function giftMeetsThreshold(subtotalCents, thresholdEur) {
    var prag = Number(thresholdEur);
    if (!isFinite(prag) || prag < 0) return true;
    if (subtotalCents === null || subtotalCents === undefined) return true;
    return Number(subtotalCents) >= Math.round(prag * 100);
  }

  /* Цена на доставката в стотинки: null докато няма избран метод, 0 при
     безплатна, иначе цената на метода. */
  function shippingCents(subtotalCents, methodPriceEur, cfg) {
    if (methodPriceEur == null) return null;
    if (isFreeShipping(subtotalCents, cfg)) return 0;
    return Math.round(methodPriceEur * 100);
  }

  /* Цена 0 в checkout/config значи „безплатен метод“ (промо на BOX NOW от
     29.09.2026 до второ нареждане). Показва се като при достигнат праг –
     „безплатно“, никога „0,00 €“. Зачертана стара цена няма, защото темата не
     знае обичайната цена – тя идва само от config. За метод с цена над 0
     изгледът е точно заварения. */
  function methodPriceView(priceEur, isFree) {
    var cents = Math.round((Number(priceEur) || 0) * 100);
    if (cents === 0) return { old: null, free: true, text: 'безплатно' };
    if (isFree) return { old: money(cents), free: true, text: 'безплатно' };
    return { old: null, free: false, text: money(cents) };
  }

  /* Текстът на реда „Доставка“ в обобщението и на „Потвърждение“. */
  function shippingText(totals) {
    if (!totals || totals.shippingCents == null) return '—';
    if (totals.isFree || totals.shippingCents === 0) return 'Безплатно';
    return money(totals.shippingCents);
  }

  function computeTotals(opts) {
    var subtotal = opts.subtotalCents;
    if (subtotal == null) {
      return { subtotalCents: null, shippingCents: null, discountCents: null, totalCents: null, isFree: false };
    }
    var ship = shippingCents(subtotal, opts.methodPriceEur, opts.cfg);
    var discount = appliedDiscount(opts.discount, subtotal, ship);
    return {
      subtotalCents: subtotal,
      shippingCents: ship,
      discountCents: discount ? discount.discountCents : null,
      /* Сървърното totalCents е истината само ако се връзва с видимите редове.
         Няма ли избран метод, доставката е неизвестна и КРАЙНА сума не
         съществува — редът остава „—". Отстъпката е доказана, сумата за
         плащане не е, а обявена сума ПОД дължимата е по-лоша от липсваща. */
      totalCents: ship == null ? null : (
        discount
          ? (discount.shippingIncluded === false ? discount.totalCents + ship : discount.totalCents)
          : subtotal + ship
      ),
      isFree: isFreeShipping(subtotal, opts.cfg)
    };
  }

  /* Сверява сървърното totalCents с видимите редове.

     Сървърът винаги обявява дали тоталът му включва доставката. Отстъпката НЕ
     зависи от метода (проверено срещу живия Shopify), затова отговор с
     shippingIncluded:false е валиден и на двете стъпки: сверява се срещу
     количка минус отстъпка, а доставката се добавя отделно, когато стане
     известна. Точно това позволява един код да струва една заявка.

     Липсва ли полето (стар сървър), оставаме на старото строго поведение —
     липсващо поле не бива да сваля проверка. */
  function discountMatchesTotals(discount, subtotalCents, shippingAmountCents) {
    if (!discount) return false;
    if (!Number.isInteger(subtotalCents)) return false;
    if (!Number.isInteger(discount.discountCents) || !Number.isInteger(discount.totalCents)) return false;
    var bezDostavka = subtotalCents - discount.discountCents;
    if (discount.shippingIncluded === false) return discount.totalCents === bezDostavka;
    if (!Number.isInteger(shippingAmountCents)) return false;
    return discount.totalCents === bezDostavka + shippingAmountCents;
  }

  function appliedDiscount(discount, subtotalCents, shippingAmountCents) {
    if (!discount || typeof discount.code !== 'string' || !discount.code) return null;
    if (!Number.isInteger(discount.discountCents) || discount.discountCents < 0) return null;
    if (!Number.isInteger(discount.totalCents) || discount.totalCents < 0) return null;
    if (!discountMatchesTotals(discount, subtotalCents, shippingAmountCents)) return null;
    return discount;
  }

  function discountView(discount, subtotalCents, shippingAmountCents) {
    var applied = appliedDiscount(discount, subtotalCents, shippingAmountCents);
    return applied ? {
      show: true,
      code: applied.code,
      discountCents: applied.discountCents
    } : { show: false, code: '', discountCents: null };
  }

  /* Прогрес „още X до безплатна доставка" — видим от стъпка 1, за да стигне
     информацията до клиента, докато още може да добави книга. */
  function freeShipProgress(subtotalCents, cfg) {
    if (!cfg || !cfg.freeShippingThresholdEur || subtotalCents == null) {
      return { show: false, remainingCents: 0, percent: 0, isFree: false };
    }
    var t = freeThresholdCents(cfg);
    if (isFreeShipping(subtotalCents, cfg)) {
      return { show: false, remainingCents: 0, percent: 100, isFree: true };
    }
    var remaining = t - subtotalCents;
    var percent = t > 0 ? Math.max(0, Math.min(100, Math.round((subtotalCents / t) * 100))) : 0;
    // При включваща граница точно на прага излиза по-горе като безплатно. Тук
    // remaining може да е 0 само при изричното freeShippingInclusive === false;
    // предпазителят show: remaining > 0 пази от подвеждащото „0 € остават“.
    return { show: remaining > 0, remainingCents: Math.max(0, remaining), percent: percent, isFree: false };
  }

  /* Стъпките имат семантични имена, а видимите им номера зависят от това дали
     има реални подаръци. Така старият тристъпков поток остава същият договор,
     вместо целият DOM да гадае кое число означава „Доставка". */
  function stepKeys(hasGift) {
    return hasGift
      ? ['gift', 'details', 'delivery', 'review']
      : ['details', 'delivery', 'review'];
  }

  function totalSteps(hasGift) {
    return stepKeys(hasGift).length;
  }

  function stepKey(step, hasGift) {
    var keys = stepKeys(hasGift);
    var n = Math.max(1, Math.min(keys.length, Number(step) || 1));
    return keys[n - 1];
  }

  function stepNumber(key, hasGift) {
    var index = stepKeys(hasGift).indexOf(key);
    return index === -1 ? null : index + 1;
  }

  function nextStep(step, hasGift) {
    return Math.min(totalSteps(hasGift), Math.max(1, Number(step) || 1) + 1);
  }

  /* Кое поле на коя стъпка живее. Стои тук, а не в попъпа, защото това е едно от
     седемте места, зашити на „3 стъпки": сгреши ли номера при подаръчен поток,
     защитната валидация връща човека на грешната стъпка и той не вижда грешката,
     която го е спряла. Тук е и тествано за двата потока. */
  var FIELD_STEP_KEYS = {
    firstName: 'details', lastName: 'details', email: 'details', phone: 'details',
    company_name: 'details', uic: 'details', vat: 'details', company_address: 'details',
    method: 'delivery', officeCity: 'delivery', office: 'delivery',
    addrCity: 'delivery', addrStreet: 'delivery', addrNo: 'delivery', addrBlock: 'delivery',
    fbCity: 'delivery', fbZip: 'delivery', fbAddress1: 'delivery',
    terms: 'review'
  };

  function stepOfField(field, hasGift) {
    var key = FIELD_STEP_KEYS[field];
    return key ? stepNumber(key, hasGift) : null;
  }

  /* Редът, в който се търси първата сгрешена стъпка. Стои до картата, а не в
     попъпа, за да може един тест да пази двете да не се разминават: поле,
     добавено само на едното място, връща човека на „Потвърждение" и грешката,
     която го е спряла, остава невидима. */
  var FIELD_ORDER = [
    'firstName', 'lastName', 'email', 'phone',
    'company_name', 'uic', 'vat', 'company_address',
    'method', 'officeCity', 'office', 'addrCity', 'addrStreet', 'addrNo', 'addrBlock',
    'fbCity', 'fbZip', 'fbAddress1', 'terms'
  ];

  /* Подаръкът и данните никога не заключват CTA-то; само доставката иска
     избран метод. Валидацията на полетата остава отделна при опит за напред. */
  function canAdvance(step, methodSelected, hasGift) {
    return stepKey(step, hasGift) !== 'delivery' || !!methodSelected;
  }

  function ctaLabel(step, methodSelected, hasGift) {
    var key = stepKey(step, hasGift);
    if (key === 'gift') return 'Продължи';
    if (key === 'details') return 'Метод на доставка';
    if (key === 'delivery') return methodSelected
      ? 'Към последната стъпка'
      : 'Избери начин на доставка';
    return 'Продължи към плащане';
  }

  function stepFlags(step, hasGift) {
    var key = stepKey(step, hasGift);
    var details = stepNumber('details', hasGift);
    var delivery = stepNumber('delivery', hasGift);
    var review = stepNumber('review', hasGift);
    var gift = stepNumber('gift', hasGift);
    return {
      currentKey: key,
      total: totalSteps(hasGift),
      giftOpen: key === 'gift', giftDone: gift !== null && step > gift,
      detailsOpen: key === 'details', detailsDone: step > details,
      deliveryOpen: key === 'delivery', deliveryDone: step > delivery,
      reviewOpen: key === 'review',
      /* Старите имена остават семантични псевдоними за трите заварени стъпки. */
      s1open: key === 'details', s1done: step > details,
      s2open: key === 'delivery', s2done: step > delivery,
      s3open: key === 'review',
      canBack: step > 1,
      reviewStep: review
    };
  }

  /* Рейлът позволява връщане назад, но не скок напред. Ограничаването до
     общия брой пази и четиристъпковия поток от несъществуваща цел. */
  function railTarget(current, n, hasGift) {
    var total = totalSteps(hasGift);
    var from = Math.max(1, Math.min(total, Number(current) || 1));
    var target = Math.max(1, Math.min(total, Number(n) || 1));
    return target <= from ? target : from;
  }

  /* Отделни градове от списък офиси — за флоу „първо град, после офис". При
     Спиди и Еконт ключът е град + пощенски код (кодът различава дублиращи се имена
     на населени места); при BOX NOW – само името (виж коментара в тялото). */
  function distinctCities(offices, courier) {
    // При BOX NOW пощенският код е на всеки автомат, не на града: групиран по
    // него, градът излиза по веднъж на всеки код („София", „София 1000",
    // „София 1324"...) и прилича на дубликат. Там се групира само по име.
    var byName = isLockerOnly(courier);
    var seen = {}, out = [];
    for (var i = 0; i < (offices || []).length; i++) {
      var o = offices[i] || {};
      if (!o.city) continue;
      var zip = byName ? '' : (o.zip || '');
      var key = o.city + '|' + zip;
      if (!seen[key]) { seen[key] = 1; out.push({ city: o.city, zip: zip }); }
    }
    return out;
  }

  /* Български телефон → +359XXXXXXXXX или null. Огледало на popup валидацията. */
  function normalizePhone(value) {
    var compact = (value || '').trim().replace(/[\s().-]/g, '');
    var n = compact;
    if (compact.indexOf('00359') === 0) n = '+359' + compact.slice(5);
    else if (compact.charAt(0) === '0') n = '+359' + compact.slice(1);
    return /^\+359\d{9}$/.test(n) ? n : null;
  }

  /* Бележката се показва само когато число НЯМА. Старият ѝ текст („ще бъде
     приложен при плащането, ако е валиден") звучеше като одобрение на код,
     който никой не е проверил – а точно това задачата тръгна да махне.
     Новият казва какво още не се е случило, без да обещава. */
  function promoNote(rawCode) {
    var code = (rawCode || '').trim().toUpperCase();
    if (!code) return null;
    return {
      code: code,
      show: true,
      text: 'Кодът „' + code + '“ е записан. Проверяваме го — сумата ще се появи тук.',
      /* Крайният текст, когато проверката е приключила БЕЗ число. „Проверяваме"
         е неточно в момент, в който вече не проверяваме нищо, а старото „ще
         бъде приложен при плащането, ако е валиден" звучеше като одобрение. */
      settledText: 'Кодът „' + code + '“ е записан. Не успяхме да го пресметнем тук.'
    };
  }

  /* Нормализира трите отговора от проверката. Всеки непълен или неочакван
     отговор остава непроверим, за да не се изтрие код поради технически проблем. */
  function discountOutcome(rawCode, response, pricing) {
    var note = promoNote(rawCode);
    var code = note ? note.code : '';
    if (!code) return { status: 'noop', code: '', discount: null, message: null };

    if (response && response.valid === true && response.deferred === false &&
        typeof response.code === 'string' && response.code &&
        Number.isInteger(response.discountCents) && response.discountCents >= 0 &&
        Number.isInteger(response.totalCents) && response.totalCents >= 0) {
      var candidate = {
        code: response.code,
        discountCents: response.discountCents,
        totalCents: response.totalCents,
        // Липсва ли полето (стар сървър), приемаме, че доставката Е включена –
        // това е заварното поведение и не отпуска проверката.
        shippingIncluded: response.shippingIncluded !== false
      };
      if (pricing && !discountMatchesTotals(candidate, pricing.subtotalCents, pricing.shippingCents)) {
        return { status: 'deferred', code: code, discount: null, message: note.text };
      }
      return {
        status: 'applied',
        code: response.code,
        discount: candidate,
        message: null
      };
    }

    if (response && response.valid === false && response.deferred === false &&
        typeof response.code === 'string' && response.code) {
      return { status: 'rejected', code: '', discount: null, message: null };
    }

    return { status: 'deferred', code: code, discount: null, message: note.settledText };
  }

  /* Единствен вход към мрежовата проверка. При празен код request изобщо не се
     извиква. 429, мрежова грешка и невалиден отговор остават непроверими. */
  function checkDiscount(rawCode, request, pricing) {
    var emptyOrDeferred = discountOutcome(rawCode, null);
    if (emptyOrDeferred.status === 'noop') return Promise.resolve(emptyOrDeferred);
    try {
      return Promise.resolve(request(emptyOrDeferred.code))
        .then(function (response) { return discountOutcome(emptyOrDeferred.code, response, pricing); })
        .catch(function () { return emptyOrDeferred; });
    } catch (e) {
      return Promise.resolve(emptyOrDeferred);
    }
  }

  /* Ключ на кеша за промокод: САМО кодът и отпечатъкът на количката.
     Методът нарочно не влиза – отстъпката не зависи от него. Смяната между два
     метода чисти кеша отвън (виж applyMethodChange и onMethodChange), за да не
     носим застояла стойност. */
  function discountCacheKey(code, cartFingerprint) {
    var c = (code || '').trim().toUpperCase();
    if (!c || !cartFingerprint) return null;
    return c + '|' + cartFingerprint;
  }

  /* Истина само когато записаният отговор е за СЪЩИЯ код и СЪЩАТА количка и
     носи годен резултат. Всичко друго връща false и заявката тръгва. */
  function cachedDiscountUsable(cache, code, cartFingerprint) {
    if (!cache || !cache.key || !cache.outcome) return false;
    var key = discountCacheKey(code, cartFingerprint);
    if (!key || cache.key !== key) return false;
    // Ключът доказва „за същия код и същата количка", но не и че записаното е
    // годно. Без това записан празен резултат би скрил и числото, и бележката.
    var o = cache.outcome;
    return o.status === 'applied' && !!o.discount &&
      typeof o.discount.code === 'string' && !!o.discount.code &&
      Number.isInteger(o.discount.discountCents) &&
      Number.isInteger(o.discount.totalCents);
  }

  /* ЕДИНСТВЕНОТО място, което решава дали да тръгне заявка. `applyPromo` вика
     само нея, за да може тестът да брои решенията върху истинския код, а не
     върху копие от него.

     Връща:
       'reuse'   – има годен кеш за същия код и същата количка; заявка НЕ тръгва
       'blocked' – друга заявка е в полет или сме в охлаждане
       'request' – тръгва заявка */
  function promoRequestPlan(opts) {
    opts = opts || {};
    if (cachedDiscountUsable(opts.cache, opts.code, opts.fingerprint)) {
      return { action: 'reuse', outcome: opts.cache.outcome };
    }
    var gate = beginDiscountCheck({
      inFlight: opts.inFlight, coolingDown: opts.coolingDown, sequence: opts.sequence
    });
    if (!gate.started) return { action: 'blocked', gate: gate };
    return { action: 'request', gate: gate };
  }

  /* Има ли количката поне един ред, с който може да тръгне поръчка. Без него
     draft-ът носи `lines: []`, сървърът го отказва с INVALID_LINES, а екранът
     показва „—" на мястото на сумите (09.10.2026, BOX NOW от телефон). */
  function cartHasLines(cart) {
    return !!(cart && Array.isArray(cart.items) && cart.items.length > 0);
  }

  function cartSignature(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    return JSON.stringify({
      items: cart.items.map(function (item) {
        return {
          variant_id: item.variant_id || item.id,
          quantity: item.quantity,
          final_price: item.final_price,
          final_line_price: item.final_line_price,
          title: item.title,
          properties: item.properties || null
        };
      }),
      attributes: cart.attributes || null,
      discount_codes: cart.discount_codes || null
    });
  }

  function cartChanged(previousCart, nextCart) {
    var previous = cartSignature(previousCart);
    return previous !== null && previous !== cartSignature(nextCart);
  }

  function beginDiscountCheck(state) {
    state = state || {};
    var sequence = state.sequence || 0;
    if (state.inFlight || state.coolingDown) {
      return { started: false, inFlight: !!state.inFlight, sequence: sequence };
    }
    return { started: true, inFlight: true, sequence: sequence + 1 };
  }

  /* Проверката тръгва и БЕЗ избран метод: кодовете от клас PRODUCT и ORDER не
     зависят от доставката (проверено срещу живия Shopify – същият вход със и
     без shippingLine дава същата отстъпка), а класът SHIPPING е изключен от
     allowlist-а на сървъра и не може да стигне до число. Количката обаче е
     задължителна – без нея няма какво да се смята. */
  function shouldRequestDiscount(cartReady, rawCode) {
    return !!cartReady && !!promoNote(rawCode);
  }

  function shouldApplyDiscountOutcome(requestSequence, currentSequence, requestCode, currentCode, status) {
    if (status === 'rejected' && requestCode === currentCode) return true;
    return requestSequence === currentSequence;
  }

  function promoFailureState(currentFailures, status) {
    if (status === 'applied') return { failures: 0, waitMs: 0 };
    var failures = Math.max(0, currentFailures || 0) + 1;
    if (failures < 3) return { failures: failures, waitMs: 0 };
    return {
      failures: failures,
      waitMs: Math.min(30000, 2000 * Math.pow(2, failures - 3))
    };
  }

  function discountLabel(code, hasCartDiscountCodes) {
    return hasCartDiscountCodes || !code ? 'Отстъпка' : 'Отстъпка (' + code + ')';
  }

  /* Meta InitiateCheckout payload от стандартния /cart.js отговор.
     Цените в cart.js са в центове; към Meta ги подаваме като EUR числа.
     Празната количка връща null: DOM обвивката не публикува събитие. */
  function metaInitiateCheckoutPayload(cart, eventId) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var numItems = items.reduce(function (count, item) {
      return count + (Number(item && item.quantity) || 0);
    }, 0);
    if (!items.length || numItems <= 0) return null;

    var totalCents = items.reduce(function (sum, item) {
      return sum + (Number(item && item.final_line_price) || 0);
    }, 0);
    return {
      value: Number((totalCents / 100).toFixed(2)),
      currency: cart.currency || 'EUR',
      num_items: numItems,
      content_ids: items.map(function (item) { return String(item && item.variant_id); }),
      contents: items.map(function (item) {
        return {
          id: String(item && item.variant_id),
          quantity: Number(item && item.quantity) || 0,
          item_price: Number(((Number(item && item.final_price) || 0) / 100).toFixed(2))
        };
      }),
      content_type: 'product',
      event_id: eventId
    };
  }

  function shouldPublishMetaCheckout(state, openSeq) {
    return !!state && state.open === true &&
      openSeq === state.metaCheckoutOpenSeq &&
      state.metaCheckoutPublishedSeq !== openSeq;
  }

  /* OpenAI checkout_started: същото правило като Meta – първият /cart.js на
     всяко отваряне, веднъж на отваряне – но със собствен брояч, защото двете
     публикации могат да се разминат (напр. липсващ пиксел). */
  function shouldPublishOpenAiCheckout(state, openSeq) {
    return !!state && state.open === true &&
      openSeq === state.metaCheckoutOpenSeq &&
      state.oaiCheckoutPublishedSeq !== openSeq;
  }

  /* Отразява записания в Shopify атрибут _oppref върху локалната количка, за да
     стигне до Draft Order заявката без нов /cart.js. Празна стойност = махнат.
     Подадени ли са атрибутите от отговора на /cart/update.js, те се взимат цели
     (същият ред на ключовете като в следващия /cart.js – иначе cartSignature
     ще види „промяна" и ще нулира промокода напразно). Връща същия обект. */
  function applyCartOppref(cart, value, attributes) {
    if (!cart || typeof cart !== 'object') return cart;
    if (attributes && typeof attributes === 'object' && !Array.isArray(attributes)) {
      cart.attributes = attributes;
      return cart;
    }
    if (!cart.attributes || typeof cart.attributes !== 'object' || Array.isArray(cart.attributes)) {
      cart.attributes = {};
    }
    if (value) cart.attributes._oppref = String(value);
    else delete cart.attributes._oppref;
    return cart;
  }

  /* Ключът на темата „Подарък при поръчка" (04.10.2026). Editera казва дали
     механизмът работи на сървъра (`giftEnabled`); темата казва дали сайтът
     изобщо го предлага. Нужни са И ДВЕТЕ: изключен ли е ключът на темата,
     попъпът не тегли заглавията, не чете сбора и не показва стъпката, каквото
     и да върне Editera. Стойността идва от `data-gift-on` и е точно „1" при
     включен ключ; всичко друго (липса, празно, „0") значи изключен.
     Връща НОВ обект и не пипа подадения. */
  function applyThemeGiftSwitch(cfg, giftOnAttr) {
    if (!cfg || typeof cfg !== 'object') return cfg;
    if (String(giftOnAttr == null ? '' : giftOnAttr).trim() === '1') return cfg;
    return Object.assign({}, cfg, { giftEnabled: false });
  }

  /* ---- „До личен адрес": едно поле „Улица или квартал" ----
     Полето търси паралелно в две номенклатури на Спиди: улици (`checkout/streets`)
     и квартали/комплекси (`checkout/complexes`). Редовете се сливат в един списък;
     всеки носи префикса си от отговора („ул.", „ж.к.", „в.з."…) – темата не пази
     свой списък с типове и не преправя имената („Младост 1" идва с малки букви и
     така се показва). Комплекс без тип (`prefix: null`) е само името. */
  var ADDR_LIST_CAP = 20;
  var ADDR_QUERY_PREFIX = /^\s*(?:ж\.?\s?к\.?|кв\.?|ул\.?|бул\.?|м\.|в\.?\s?з\.)\s*/i;

  function addrItemLabel(item) {
    if (!item) return '';
    return ((item.prefix ? item.prefix + ' ' : '') + (item.name || '')).trim();
  }

  function addrStreetItem(st) {
    st = st || {};
    return { kind: 'street', id: st.streetId, name: st.name || '', prefix: st.type || null };
  }

  function addrComplexItem(c) {
    c = c || {};
    return { kind: 'complex', id: c.complexId, name: c.name || '', prefix: c.prefix || null };
  }

  /* Слят списък с таван. Ако едната страна е дълга, не изяжда другата: всяка
     има право на половината, а празното място се дава на другата. Отгоре са
     имената, които започват с написаното (само в смесен списък); при равенство
     улиците са първи. Латиница в заявката не се сравнява (сървърът я транслитерира), тогава
     редът е само „улици, после квартали". */
  function addrSuggestions(streets, complexes, q, cap) {
    var max = cap || ADDR_LIST_CAP;
    var s = (streets || []).map(addrStreetItem);
    var c = (complexes || []).map(addrComplexItem);
    var half = Math.ceil(max / 2);
    var nS = Math.min(s.length, Math.max(half, max - c.length));
    var nC = Math.min(c.length, max - nS);
    var merged = s.slice(0, nS).concat(c.slice(0, nC));
    var needle = String(q || '').replace(ADDR_QUERY_PREFIX, '').trim().toLowerCase();
    // Само улици или само квартали – редът е точно този от Спиди, както досега.
    if (!needle || !nS || !nC) return merged;
    return merged
      .map(function (item, i) {
        return { item: item, i: i, rank: item.name.toLowerCase().indexOf(needle) === 0 ? 0 : 1 };
      })
      .sort(function (a, b) { return a.rank - b.rank || a.i - b.i; })
      .map(function (x) { return x.item; });
  }

  /* Какво прави попъпът с двата отговора (null = мрежова грешка за тази заявка).
     Резервният ръчен адрес (Вариант А) се отваря само при реален отказ на Спиди:
     - улиците казват COURIER_UNAVAILABLE → резервен път, точно както преди;
     - кварталите казват COURIER_UNAVAILABLE и улици няма → резервен път, иначе
       човек с адрес в ж.к. стои пред празен списък без изход.
     Празен списък без грешка НЕ отваря свободен текст. */
  function addrSearchOutcome(streetsRes, complexesRes, q, cap) {
    var down = 'COURIER_UNAVAILABLE';
    if (streetsRes && streetsRes.error === down) return { fallback: true, items: [] };
    var streets = (streetsRes && streetsRes.streets) || [];
    if (complexesRes && complexesRes.error === down && !streets.length) return { fallback: true, items: [] };
    var complexes = (complexesRes && complexesRes.complexes) || [];
    return { fallback: false, items: addrSuggestions(streets, complexes, q, cap) };
  }

  // При улица номерът е задължителен; при квартал – блокът.
  function addrRequired(kind) {
    return { no: kind === 'street', block: kind === 'complex' };
  }

  /* Грешките на адресната част (без резервния път). `vals` е { no, block,
     entrance, floor, apt } вече изчистени. Ключовете са полетата на попъпа. */
  function addrErrors(pick, siteChosen, vals) {
    vals = vals || {};
    if (!siteChosen) return { addrCity: 'Избери град от списъка.' };
    if (!pick || pick.id == null) return { addrStreet: 'Избери улица или квартал от списъка.' };
    if (pick.kind === 'complex') return vals.block ? {} : { addrBlock: 'Въведи блок.' };
    return vals.no ? {} : { addrNo: 'Въведи номер.' };
  }

  /* `address1` към draft-а – договорът с бекенда остава град/пощ.код/address1.
     Улица (байт за байт както досега): „ул. Витоша №5, бл. 2, вх. А, ет. 3, ап. 12".
     Квартал: „ж.к. Младост 1, бл. 23[, №5][, вх. А][, ет. 3][, ап. 12]" – Ф1 чете
     името до първата запетая и блока след нея, затова номерът (по желание) стои
     след блока, не до името. Без тип – само името, без измислен префикс. */
  function addrLine1(pick, vals) {
    vals = vals || {};
    var parts = [];
    if (pick && pick.kind === 'complex') {
      parts.push(addrItemLabel(pick));
      if (vals.block) parts.push('бл. ' + vals.block);
      if (vals.no) parts.push('№' + vals.no);
    } else {
      var head = (pick && pick.prefix ? pick.prefix + ' ' : '') + ((pick && pick.name) || '') + ' №' + (vals.no || '');
      parts.push(head.trim());
      if (vals.block) parts.push('бл. ' + vals.block);
    }
    if (vals.entrance) parts.push('вх. ' + vals.entrance);
    if (vals.floor) parts.push('ет. ' + vals.floor);
    if (vals.apt) parts.push('ап. ' + vals.apt);
    return parts.join(', ');
  }

  // Краткият ред в обобщението на стъпка „Доставка" (без град).
  function addrRecap(pick, vals) {
    vals = vals || {};
    if (!pick) return '';
    if (pick.kind === 'complex') {
      return addrItemLabel(pick) + (vals.block ? ', бл. ' + vals.block : '');
    }
    var street = (pick.prefix ? pick.prefix + ' ' : '') + (pick.name || '');
    return (street + (vals.no ? ' №' + vals.no : '')).trim();
  }

  /* Номерата от номенклатурата на Спиди за същия избор, от който addrLine1
     сглобява `address1` – Ф1 ги взима наготово вместо да разчита текста
     (договорът: speedyAdresNomera.ts в marmot-library, `adres-nomera` част А).
     Улица ИЛИ комплекс; `f2_street_no` само при улица; празно поле не се праща.
     Стойностите са същите изчистени низове като в текста – Ф1 приема номерата
     само ако казват същото. Без град или без избор от списъка → null. */
  var ADDR_ATTR_KEYS = ['f2_site_id', 'f2_street_id', 'f2_street_no', 'f2_complex_id',
    'f2_block', 'f2_entrance', 'f2_floor', 'f2_apartment'];

  function addrAttributes(siteId, pick, vals) {
    vals = vals || {};
    if (siteId == null || siteId === '' || !pick || pick.id == null || pick.id === '') return null;
    var out = { f2_site_id: String(siteId) };
    if (pick.kind === 'complex') {
      out.f2_complex_id = String(pick.id);
    } else {
      out.f2_street_id = String(pick.id);
      if (vals.no) out.f2_street_no = vals.no;
    }
    if (vals.block) out.f2_block = vals.block;
    if (vals.entrance) out.f2_entrance = vals.entrance;
    if (vals.floor) out.f2_floor = vals.floor;
    if (vals.apt) out.f2_apartment = vals.apt;
    // Ф1 приема поле до 10 знака без запетая; иначе отхвърля ВСИЧКИ номера.
    // Тогава не ги пращаме – намерението е изрично, Ф1 чете текста.
    for (var key in out) {
      if (out[key].length > 10 || /[,\n]/.test(out[key])) return null;
    }
    return out;
  }

  /* Атрибутите на количката (обект или масив, както ги дава /cart.js) плюс
     номерата → обект. Заварени f2_* адресни ключове падат първо, за да не се
     смесят улица и комплекс от различни избори. Без номера – атрибутите
     остават същите (същата референция). */
  function withAddrAttributes(attributes, nomera) {
    if (!nomera) return attributes;
    var out = {};
    if (Array.isArray(attributes)) {
      attributes.forEach(function (a) { if (a && a.name != null) out[a.name] = a.value; });
    } else if (attributes && typeof attributes === 'object') {
      for (var k in attributes) {
        if (Object.prototype.hasOwnProperty.call(attributes, k)) out[k] = attributes[k];
      }
    }
    ADDR_ATTR_KEYS.forEach(function (key) { delete out[key]; });
    for (var n in nomera) {
      if (Object.prototype.hasOwnProperty.call(nomera, n)) out[n] = nomera[n];
    }
    return out;
  }

  return {
    BGN_RATE: BGN_RATE,
    money: money,
    methodKey: methodKey,
    METHOD_LABELS: METHOD_LABELS,
    methodHint: methodHint,
    hiddenRevealRequested: hiddenRevealRequested,
    visibleMethods: visibleMethods,
    cartHref: cartHref,
    isLockerOnly: isLockerOnly,
    officeTexts: officeTexts,
    officeHintText: officeHintText,
    officeView: officeView,
    applyMethodChange: applyMethodChange,
    isFreeShipping: isFreeShipping,
    giftMeetsThreshold: giftMeetsThreshold,
    applyThemeGiftSwitch: applyThemeGiftSwitch,
    shippingCents: shippingCents,
    computeTotals: computeTotals,
    methodPriceView: methodPriceView,
    shippingText: shippingText,
    discountMatchesTotals: discountMatchesTotals,
    discountView: discountView,
    freeShipProgress: freeShipProgress,
    stepKeys: stepKeys,
    totalSteps: totalSteps,
    stepKey: stepKey,
    stepNumber: stepNumber,
    nextStep: nextStep,
    fieldStepKeys: FIELD_STEP_KEYS,
    fieldOrder: FIELD_ORDER,
    stepOfField: stepOfField,
    canAdvance: canAdvance,
    ctaLabel: ctaLabel,
    stepFlags: stepFlags,
    railTarget: railTarget,
    distinctCities: distinctCities,
    normalizePhone: normalizePhone,
    promoNote: promoNote,
    discountOutcome: discountOutcome,
    checkDiscount: checkDiscount,
    cartSignature: cartSignature,
    cartChanged: cartChanged,
    cartHasLines: cartHasLines,
    beginDiscountCheck: beginDiscountCheck,
    shouldRequestDiscount: shouldRequestDiscount,
    discountCacheKey: discountCacheKey,
    cachedDiscountUsable: cachedDiscountUsable,
    promoRequestPlan: promoRequestPlan,
    shouldApplyDiscountOutcome: shouldApplyDiscountOutcome,
    promoFailureState: promoFailureState,
    discountLabel: discountLabel,
    metaInitiateCheckoutPayload: metaInitiateCheckoutPayload,
    shouldPublishMetaCheckout: shouldPublishMetaCheckout,
    shouldPublishOpenAiCheckout: shouldPublishOpenAiCheckout,
    applyCartOppref: applyCartOppref,
    ADDR_LIST_CAP: ADDR_LIST_CAP,
    addrItemLabel: addrItemLabel,
    addrSuggestions: addrSuggestions,
    addrSearchOutcome: addrSearchOutcome,
    addrRequired: addrRequired,
    addrErrors: addrErrors,
    addrLine1: addrLine1,
    addrRecap: addrRecap,
    ADDR_ATTR_KEYS: ADDR_ATTR_KEYS,
    addrAttributes: addrAttributes,
    withAddrAttributes: withAddrAttributes,
    PAYMENT_NOTE: PAYMENT_NOTE,
    paymentNoteText: paymentNoteText
  };
});
